import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20" aria-label="开始选群">
      <div className="mx-auto max-w-6xl">
        <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-primary-600 to-primary-500 px-6 py-12 md:px-12 md:py-16">
          <span className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-white/10"></span>
          <span className="pointer-events-none absolute -bottom-16 right-24 h-48 w-48 rounded-full bg-accent-500/20"></span>

          <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl leading-snug text-background-50 md:text-4xl">
                别再一个个试群了，从排行开始挑
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-50/85 md:text-base">
                排行榜按综合分数排序，并支持按娱乐八卦、追剧、时事等方向筛选。先找到对味的方向，再看活跃度与口碑，选群这件事其实可以很轻松。
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row lg:flex-col">
              <Link
                to="/ranking"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 font-label text-sm text-primary-700 transition-colors hover:bg-background-100"
              >
                <i className="ri-trophy-line"></i>
                查看群组排行
              </Link>
              <Link
                to="/guide"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-white/10"
              >
                <i className="ri-book-open-line"></i>
                学习选群方法
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}